import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseStatistic } from '@mtgame/core';

@Component({
  selector: 'mtg-rugby-statistic-leaders',
  templateUrl: './rugby-statistic-leaders.component.html',
  styleUrls: ['../styles/shared.scss', './rugby-statistic-leaders.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RugbyStatisticLeadersComponent {
  @Input()
  statistic: BaseStatistic[];
  @Input()
  seasonId: number;

  playersParams = [
    {
      id: 'points',
      title: 'Очки',
    },
    {
      id: 'tries',
      title: 'Попытки',
    },
    {
      id: 'totalGoals',
      title: 'Голы'
    },
  ];
  playersParam = this.playersParams[0];
}
